var map = {
	"./bulb.png": 5238,
	"./illustrate_1.png": 9690,
	"./illustrate_2.png": 3921,
	"./illustrate_3.png": 2792,
	"./illustrate_4.png": 1783,
	"./install1-1.png": 7635,
	"./install1-2.png": 4424,
	"./install1-3.png": 721,
	"./install1-4.png": 8254,
	"./install2-1.png": 7856,
	"./install2-2.png": 7707,
	"./install2-3.png": 6578,
	"./install2-4.png": 2925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;